import { create } from 'zustand'
import rushdropApi from '../services/rushdropApi'

let eventRequestId = 0
let weeklyRequestId = 0

/**
 * Zustand store режима Rush Drop (backend-модуль fast_event).
 * Хранит полный ответ GET /api/fast-event/ и состояние загрузки.
 * Polling и локальные таймеры живут на странице RushDrop.jsx.
 */
const useRushdropStore = create((set) => ({
  // Полный ответ /api/fast-event/ (или { enabled: false })
  data: null,
  isLoading: false,
  error: null,

  // Загрузка данных эвента; silent — фоновое обновление без skeleton и без сброса ошибки
  loadEvent: async ({ silent = false, signal } = {}) => {
    const requestId = ++eventRequestId
    if (!silent) {
      set({ isLoading: true, error: null })
    }

    try {
      const response = await rushdropApi.getEvent(signal)
      if (requestId !== eventRequestId) return null
      set({ data: response, isLoading: false, error: null })
      return response
    } catch (error) {
      if (requestId !== eventRequestId) return null
      // Отмена запроса при размонтировании — не считаем ошибкой
      if (error?.name === 'AbortError') {
        return null
      }
      console.error('❌ Rush Drop: ошибка загрузки эвента:', error)
      if (!silent) {
        set({ isLoading: false, error: error?.message || 'error backend' })
      }
      return null
    }
  },

  // Ответ GET /api/fast-event/weekly/ (или { enabled: false } вне окна розыгрыша)
  weeklyData: null,
  weeklyLoading: false,
  weeklyError: null,

  // Загрузка недельного розыгрыша; silent — фоновый поллинг без skeleton
  loadWeekly: async ({ silent = false, signal } = {}) => {
    const requestId = ++weeklyRequestId
    if (!silent) {
      set({ weeklyLoading: true, weeklyError: null })
    }

    try {
      const response = await rushdropApi.getWeekly(signal)
      if (requestId !== weeklyRequestId) return null
      set({ weeklyData: response, weeklyLoading: false, weeklyError: null })
      return response
    } catch (error) {
      if (requestId !== weeklyRequestId) return null
      // Отмена запроса при размонтировании — не считаем ошибкой
      if (error?.name === 'AbortError') {
        return null
      }
      console.error('❌ Rush Drop: ошибка загрузки недельного розыгрыша:', error)
      if (!silent) {
        set({ weeklyLoading: false, weeklyError: error?.message || 'error backend' })
      }
      return null
    }
  },

  reset: () => {
    eventRequestId += 1
    weeklyRequestId += 1
    set({
      data: null,
      isLoading: false,
      error: null,
      weeklyData: null,
      weeklyLoading: false,
      weeklyError: null
    })
  }
}))

export default useRushdropStore
